import BaseApiRequestService from './BaseApiRequestService';

class InsurersApiRequestService extends BaseApiRequestService {
  protected readonly serviceURL = window.location.host.startsWith('localhost') ? 'http://localhost:3099' : 'https://439zisrgu2.execute-api.us-east-1.amazonaws.com/prod/insurers-service';
}

export default new InsurersApiRequestService();
